import toFixed from './toFixed';

const humanizeBalance = (balance: number) => toFixed(balance, 2);

export default humanizeBalance;
